var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"text-align":"center","width":"100%"}},[_c('h1',[_vm._v("FAQs")]),_c('VueFaqAccordion',{staticClass:"faqs",attrs:{"items":_vm.faqs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }